export const ABOUT_PREFIX = "About";

export const ABOUT_CLASSES = {
  title: `${ABOUT_PREFIX}-title`,
  text: `${ABOUT_PREFIX}-text`,
  showMore: `${ABOUT_PREFIX}-showMore`,
  hideOnMobile: `${ABOUT_PREFIX}-hideOnMobile`,
};
